import axios from 'axios';

// Axios instance to use everywhere in the app
const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_SERVER_ROOT || 'http://localhost:4000',
  headers: {
    'Content-Type': 'application/json',
  },
});

const baseUrl = '/budget-calculator';

export const runBudgetCalculator = async function (inputs: any) {
    const response = await axiosInstance.post(`${baseUrl}/run`, {inputs: inputs});
    return response.data;
};
